<div class="title-area">
  <div class="title-header">
    <h2 class="title">マスタ設定<span class="pc-only-note">（PCのみ対応）</span></h2>

    <button
      mat-raised-button
      color="warn"
      class="tag-btn"
      [disabled]="showSpinner"
      (click)="onTagRegist()">
      タグ管理
    </button>
  </div>
  <div class="title-sub-row">
    <span class="title-desc">
      上位の分類をスキップして下位の分類を登録する場合は、スキップする分類の名称を #skip と記載してください。スキップした分類は、自動で1行目に並び変えて保存されます。
    </span>
  </div>
</div>

@if (showSpinner) {
  <div class="spinner center">
    <mat-spinner></mat-spinner>
  </div>
} @else {

  <form [formGroup]="form">
    <div class="card-grid">
    <div *ngFor="let m of masterTypes; let last = last">
      <div class="card" *ngIf="m.type <= 3">
        <div class="title-sub-row">
          <div class="title-left">
            <h3>{{ m.label }}マスタ</h3>
            <div class="name-count-master">
              <input
                class="count-input"
                [formControlName]="m.form + '_member_count'"
                maxlength="5"
                inputmode="numeric"
                (input)="onlyNumber($event)"
                [readonly]="deleteMode[m.type]"
                (keydown.enter)="$event.preventDefault()"
              />
              <span class="num">人</span>
            </div>
          </div>
          <mat-dialog-actions align="end">
            <button mat-raised-button type="button" class="basicinfo" (click)="onDelete(m.type)"  (keydown.enter)="$event.preventDefault()">{{ deleteMode[m.type] ? '編集モード' : '削除モード' }}</button>
          </mat-dialog-actions>

        </div>

        <div class="category-row" [ngClass]="{'two-column': m.type === 4 || m.type === 5}">

          <!-- 中分類 -->
          <div class="category-column"
            [ngClass]="{'no-border': m.type === 4 || m.type === 5}">

            <h4 *ngIf="m.type !== 4 && m.type !== 5">
              {{ m.label }} > 中分類
            </h4>

            <div
              [formArrayName]="m.form"
              cdkDropList
              (cdkDropListDropped)="dropParent($event, form.get(m.form))"
              class="drag-list"
            >

            <ng-container *ngFor="let parent of form.get(m.form).controls; let i = index">
              <div
                class="drag-row"
                *ngIf="!parent.get('delete')?.value"
                [formGroupName]="i"
                cdkDrag
                [cdkDragDisabled]="deleteMode[m.type]"
                (click)="selectParent(m.type, i)"
                [class.selected]="selectedParentIndex[m.type] === i"
              >

              <div class="icon-area">

                <button
                type="button"
                mat-icon-button
                class="delete-btn"
                *ngIf="deleteMode[m.type]"
                (click)="deleteNode($event, parent, m.type, i)">
                <img src="assets/unionnest/close.png" class="close">
              </button>


                <mat-icon *ngIf="!deleteMode[m.type]" cdkDragHandle class="drag">
                  drag_indicator
                </mat-icon>

              </div>

                <div class="name-count-wrapper">
                <div class="name-count">
                  <input class="name-input" formControlName="name" maxlength="20" [readonly]="deleteMode[m.type]" [class.error-line]="isParentError(parent)" [ngClass]="{'name-input-wide': m.type === 4 || m.type === 5}"  (keydown.enter)="$event.preventDefault()"/>

                    <span>/</span>

                    <input
                      class="count-input"
                      formControlName="member_count"
                      maxlength="5"
                      inputmode="numeric"
                      (input)="onlyNumber($event)"
                      [readonly]="deleteMode[m.type]"
                      (keydown.enter)="$event.preventDefault()"
                    />

                    <span class="num">人</span>
                </div>
                  <span class="error-text" *ngIf="hasChildError(parent)">
                    小分類等が未入力です。
                  </span>
                </div>

                <img
                src="\assets\unionnest\arrow_circle_right.png"
                class="arrow"
                [class.arrow-hidden]="selectedParentIndex[m.type] !== i"
              />

              </div>
            </ng-container>

            </div>

            <button mat-button type="button" class="add-btn" (click)="addParent(m.type)" *ngIf="!deleteMode[m.type]" (keydown.enter)="$event.preventDefault()">
              +追加
            </button>

          </div>

          <!-- 小分類 -->
          <div class="category-column-child" *ngIf="m.type !== 4 && m.type !== 5 && selectedParentIndex[m.type] !== -1">

            <h4>{{ getTypeArray(m.form).at(selectedParentIndex[m.type]).get('name')?.value }} > 小分類</h4>

            <ng-container *ngIf="hasVisibleChildren(m.form, m.type)">

              <div [formGroup]="getTypeArray(m.form).at(selectedParentIndex[m.type])">

                <div
                  formArrayName="children"
                  cdkDropList
                  (cdkDropListDropped)="dropChild($event, getTypeArray(m.form), selectedParentIndex[m.type])"
                  class="drag-list"
                >

                <ng-container *ngFor="let child of children(getTypeArray(m.form), selectedParentIndex[m.type]).controls; let j = index">
                  <div
                    class="drag-row"
                    *ngIf="!child.get('delete')?.value"
                    [formGroupName]="j"
                    cdkDrag
                    [cdkDragDisabled]="deleteMode[m.type]"
                    (click)="selectChild(m.type, j)"
                    [class.selected]="selectedChildIndex[m.type] === j"
                  >

                  <div class="icon-area">

                    <button
                    type="button"
                    mat-icon-button
                    class="delete-btn"
                    *ngIf="deleteMode[m.type]"
                    (click)="deleteNode($event, child, m.type, j)">
                    <img src="assets/unionnest/close.png" class="close">
                  </button>

                    <mat-icon *ngIf="!deleteMode[m.type]" cdkDragHandle class="drag">
                      drag_indicator
                    </mat-icon>

                  </div>
                  <div class="name-count-wrapper">
                    <div class="name-count">
                      <input class="name-input" formControlName="name" [readonly]="deleteMode[m.type]" maxlength="20" [class.error-line]="isChildError(child)"  (keydown.enter)="$event.preventDefault()"/>

                      <span>/</span>

                      <input
                        class="count-input"
                        formControlName="member_count"
                        maxlength="5"
                        inputmode="numeric"
                        (input)="onlyNumber($event)"
                        [readonly]="deleteMode[m.type]"
                        (keydown.enter)="$event.preventDefault()"
                      />

                      <span class="num">人</span>
                    </div>
                    <span class="error-text" *ngIf="hasChildError(child)">
                      最小分類が未入力です。
                    </span>
                  </div>

                    <img
                    src="\assets\unionnest\arrow_circle_right.png"
                    class="arrow"
                    [class.arrow-hidden]="selectedChildIndex[m.type] !== j"
                  />

                  </div>
                </ng-container>

                </div>

              </div>
            </ng-container>

              <button
                mat-button
                type="button"
                class="add-btn"
                (click)="addChild(getTypeArray(m.form), selectedParentIndex[m.type])"
                *ngIf="!deleteMode[m.type]"
                (keydown.enter)="$event.preventDefault()"
              >
                +追加
              </button>


          </div>
          <div class="category-column" *ngIf="m.type !== 4 && m.type !== 5 && selectedChildIndex[m.type] !== -1">

            <h4>
              {{
                  getTypeArray(m.form)
                    .at(selectedParentIndex[m.type])
                    .get('children')
                    .at(selectedChildIndex[m.type])
                    .get('name')?.value
              }} > 職場/店舗
              </h4>

            <ng-container *ngIf="hasVisibleGrandChildren(m.form, m.type)">

              <div cdkDropList (cdkDropListDropped)="dropGrandChild($event, getTypeArray(m.form), selectedParentIndex[m.type], selectedChildIndex[m.type])" class="drag-list">

                <ng-container *ngFor="let gc of grandChildren(getTypeArray(m.form), selectedParentIndex[m.type], selectedChildIndex[m.type]).controls; let k = index">
                <div class="drag-row-gc"
                *ngIf="!gc.get('delete')?.value"
                [formGroup]="gc"
                cdkDrag
                [cdkDragDisabled]="deleteMode[m.type]"
              >

                <div class="icon-area">

                  <button
                    type="button"
                    mat-icon-button
                    class="delete-btn"
                    *ngIf="deleteMode[m.type]"
                    (click)="deleteNode($event, gc, m.type, k)">
                    <img src="assets/unionnest/close.png" class="close">
                  </button>

                  <mat-icon *ngIf="!deleteMode[m.type]" cdkDragHandle class="drag gc">
                    drag_indicator
                  </mat-icon>

                </div>

                <div class="name-count-wrapper-gc">
                  <div class="relation-row">
                    <div class="relation-trigger" #relationTrigger>
                      <mat-form-field class="relation-select no-line">
                        <mat-select
                          #relationSelect
                          formControlName="relation"
                          panelClass="relation-panel"
                          [panelWidth]="null"
                          (openedChange)="onRelationOpen($event, relationSelect, relationTrigger)">
                          <mat-option [value]="0">直接</mat-option>
                          <mat-option [value]="1">間接</mat-option>
                          <mat-option [value]="2">混合</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="tag-area">

                      <span class="tag-name">
                        {{ getTagName(gc.get('tag_id')?.value) }}
                      </span>

                      <div class="tag-trigger" #tagTrigger>

                        <img
                          src="assets/unionnest/tag.png"
                          class="tag-icon"
                          (click)="openTagSelect(tagSelect)">

                          <mat-form-field class="hidden-tag-select">
                            <mat-select
                              #tagSelect
                              formControlName="tag_id"
                              panelClass="tag-panel"
                              [panelWidth]="panelWidth"
                              (openedChange)="onTagOpen($event, tagSelect, tagTrigger)"
                              (selectionChange)="changeTag(gc, $event.value)">

                              <mat-option [value]="null"></mat-option>
                              <mat-option
                                *ngFor="let tag of tagList"
                                [value]="tag.id">
                                {{ tag.title }}

                              </mat-option>

                            </mat-select>
                          </mat-form-field>
                      </div>

                    </div>
                  </div>

                  <div class="name-count">
                    <input class="name-input gc-name-input"
                      formControlName="name"
                      maxlength="50"
                      [readonly]="deleteMode[m.type]"
                      [class.error-line]="gc.get('name')?.invalid && !gc.get('delete')?.value"
                      (keydown.enter)="$event.preventDefault()"/>

                      <span>/</span>

                      <input
                        class="count-input"
                        formControlName="member_count"
                        maxlength="5"
                        inputmode="numeric"
                        (input)="onlyNumber($event)"
                        [readonly]="deleteMode[m.type]"
                        (keydown.enter)="$event.preventDefault()"
                      />

                      <span class="num">人</span>
                  </div>
                </div>

              </div>
            </ng-container>

              </div>
            </ng-container>

              <button
                mat-button
                type="button"
                class="add-btn"
                (click)="addGrandChild(getTypeArray(m.form), selectedParentIndex[m.type], selectedChildIndex[m.type])"
                *ngIf="!deleteMode[m.type]"
                (keydown.enter)="$event.preventDefault()"
              >
                +追加
              </button>

          </div>

        </div>

        <div class="button-area">
          <div class="signup-wrapper">
            <button
            mat-raised-button
            [ngClass]="{'delete-mode-btn': deleteMode[m.type], 'yes-btn': !deleteMode[m.type]}"
            (click)="deleteMode[m.type] ? onDel(m.type) : onSave(m.type)"
            [disabled]="
              deleteMode[m.type] ||
              isTypeInvalid(m.form) ||
              cardLoading?.[m?.type]
          "
          >
          保存
          </button>
          @if (cardLoading?.[m?.type]) {
              <mat-spinner diameter="28" class="spinner2"></mat-spinner>
          }
        </div>
      </div>
    </div>
    <div class="card-footer" *ngIf="history?.[m.type]?.length && m.type <= 3">
      最終更新 {{ formatDate(history[m.type][0].created_at) }}
      &nbsp;&nbsp;
      {{ history[m.type][0].officialposition_name }}
      {{ history[m.type][0].updated_name }}
    </div>
    <div class="card-footer" *ngIf="!history?.[m.type]?.length && m.type <= 3">
      最終更新 -
    </div>

    </div>

    <div class="card-row">
      <div class="left-column">
        <ng-container *ngFor="let m of masterTypes">
          <div *ngIf="m.type === 4">
          <div class="card half">
            <div class="title-sub-row2">
              <h3>{{ m.label }}マスタ</h3>
              <mat-dialog-actions align="end">
                <button mat-raised-button type="button" class="basicinfo" (click)="onDelete(m.type)">{{ deleteMode[m.type] ? '編集モード' : '削除モード' }}</button>
              </mat-dialog-actions>

            </div>

            <div class="category-row" [ngClass]="{'two-column': m.type === 4 || m.type === 5}">

              <!-- 中分類 -->
              <div class="category-column"
                [ngClass]="{'no-border': m.type === 4 || m.type === 5}">

                <h4 *ngIf="m.type !== 4 && m.type !== 5">
                  {{ m.label }} > 中分類
                </h4>

                <div
                  [formArrayName]="m.form"
                  cdkDropList
                  (cdkDropListDropped)="dropParent($event, form.get(m.form))"
                  class="drag-list"
                >

                <ng-container *ngFor="let parent of form.get(m.form).controls; let i = index">
                  <div
                    class="drag-row"
                    *ngIf="!parent.get('delete')?.value"
                    [formGroupName]="i"
                    cdkDrag
                    [cdkDragDisabled]="deleteMode[m.type]"
                    (click)="selectParent(m.type, i)"
                    [class.selected]="selectedParentIndex[m.type] === i"
                  >

                  <div class="icon-area">

                    <button
                    type="button"
                    mat-icon-button
                    class="delete-btn"
                    *ngIf="deleteMode[m.type]"
                    (click)="deleteNode($event, parent, m.type, i)">
                    <img src="assets/unionnest/close.png" class="close">
                  </button>


                    <mat-icon *ngIf="!deleteMode[m.type]" cdkDragHandle class="drag">
                      drag_indicator
                    </mat-icon>

                  </div>

                    <div class="name-count-wrapper">
                    <div class="name-count">
                      <input class="name-input" formControlName="name" maxlength="20" [readonly]="deleteMode[m.type]" [class.error-line]="isParentError(parent)" [ngClass]="{'name-input-wide': m.type === 4 || m.type === 5}"/>

                      <div *ngIf="m.type !== 4 && m.type !== 5">
                      <span class="slash" >/</span>

                      <input
                        class="count-input"
                        formControlName="member_count"
                        maxlength="5"
                        inputmode="numeric"
                        (input)="onlyNumber($event)"
                        [readonly]="deleteMode[m.type]"
                      />

                      <span class="num">人</span>
                    </div>
                  </div>
                      <span class="error-text" *ngIf="hasChildError(parent)">
                        小分類等が未入力です。
                      </span>
                    </div>

                  </div>
                </ng-container>

                </div>

                <button mat-button type="button" class="add-btn" (click)="addParent(m.type)" *ngIf="!deleteMode[m.type]" (keydown.enter)="$event.preventDefault()">
                  +追加
                </button>

              </div>
            </div>

            <div class="button-area">
              <div class="signup-wrapper">
                <button
                mat-raised-button
                [ngClass]="{'delete-mode-btn': deleteMode[m.type], 'yes-btn': !deleteMode[m.type]}"
                (click)="deleteMode[m.type] ? onDel(m.type) : onSave(m.type)"
                [disabled]="
                  deleteMode[m.type] ||
                  isTypeInvalid(m.form) ||
                  cardLoading?.[m?.type]
              "
              >
              保存
              </button>
              @if (cardLoading?.[m?.type]) {
                  <mat-spinner diameter="28" class="spinner2"></mat-spinner>
              }
            </div>
          </div>
          </div>
          <div class="card-footer3" *ngIf="history?.[m.type]?.length && (m.type === 4)">
            最終更新 {{ formatDate(history[m.type][0].created_at) }}
            &nbsp;&nbsp;
            {{ history[m.type][0].officialposition_name }}
            {{ history[m.type][0].updated_name }}
          </div>
          <div class="card-footer3" *ngIf="!history?.[m.type]?.length && (m.type === 4)">
            最終更新 -
          </div>
        </div>
        </ng-container>
      </div>
      <div class="right-column">
        <!-- 空 -->
      </div>
    </div>



    <div class="card-row">
      <div class="left-column">
        <ng-container *ngFor="let m of masterTypes">
          <div *ngIf="m.type === 5">
          <div class="card half">
            <div class="title-sub-row2">
              <h3>{{ m.label }}マスタ</h3>
              <mat-dialog-actions align="end">
                <button mat-raised-button type="button" class="basicinfo" (click)="onDelete(m.type)" (keydown.enter)="$event.preventDefault()">{{ deleteMode[m.type] ? '編集モード' : '削除モード' }}</button>
              </mat-dialog-actions>
            </div>

            <div class="survey-col-header" *ngIf="hasVisibleParents(m.form)">
              <span class="survey-col-header-survey">アンケート回答</span>
              <span class="survey-col-header-authority" *ngIf="m.type === 5">権限</span>
            </div>

            <div class="category-row two-column">

              <div class="category-column no-border">

                <div
                  [formArrayName]="m.form"
                  cdkDropList
                  (cdkDropListDropped)="dropParent($event, form.get(m.form))"
                  class="drag-list"
                >

                <ng-container *ngFor="let parent of form.get(m.form).controls; let i = index">
                  <div
                    class="drag-row"
                    *ngIf="!parent.get('delete')?.value"
                    [formGroupName]="i"
                    cdkDrag
                    [cdkDragDisabled]="deleteMode[m.type]"
                    (click)="selectParent(m.type, i)"
                    [class.selected]="selectedParentIndex[m.type] === i"
                    [class.role-locked]="isRoleLocked(parent)"
                  >

                  <div class="icon-area">

                    <!-- 変更不可の役職は×を出さない（行の位置がずれないよう領域だけ確保する） -->
                    <button
                    type="button"
                    mat-icon-button
                    class="delete-btn"
                    [class.delete-btn-hidden]="isRoleLocked(parent)"
                    [disabled]="isRoleLocked(parent)"
                    *ngIf="deleteMode[m.type]"
                    (click)="deleteNode($event, parent, m.type, i)">
                    <img src="assets/unionnest/close.png" class="close">
                  </button>

                    <mat-icon *ngIf="!deleteMode[m.type]" cdkDragHandle class="drag">
                      drag_indicator
                    </mat-icon>

                  </div>

                    <div class="role-underline-row">
                      <input class="name-input name-input-role" formControlName="name" maxlength="20" [readonly]="deleteMode[m.type] || isRoleLocked(parent)" [class.error-line]="isParentError(parent)"/>
                      <mat-checkbox
                        class="survey-checkbox thin-checkbox"
                        [class.checkbox-locked]="deleteMode[m.type] || isRoleLocked(parent)"
                        formControlName="survey_target"
                        (click)="$event.stopPropagation()"
                      ></mat-checkbox>
                      <div class="authority-trigger" #authorityTrigger (click)="$event.stopPropagation()">
                        <mat-form-field class="authority-select no-line">
                          <mat-select
                            #authoritySelect
                            formControlName="authority"
                            panelClass="authority-panel"
                            [panelWidth]="null"
                            [disabled]="deleteMode[m.type] || isRoleLocked(parent)"
                            (openedChange)="onRelationOpen($event, authoritySelect, authorityTrigger)">
                            @if (canSelectAuthority(parent, 0)) {
                              <mat-option [value]="0">管理</mat-option>
                            }
                            @if (canSelectAuthority(parent, 1)) {
                              <mat-option [value]="1">準管理</mat-option>
                            }
                            <mat-option [value]="2">運用</mat-option>
                            <mat-option [value]="3">メンバー</mat-option>
                            <mat-option [value]="4">なし</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>

                  </div>
                </ng-container>

                </div>

                <button mat-button type="button" class="add-btn" (click)="addParent(m.type)" *ngIf="!deleteMode[m.type]" (keydown.enter)="$event.preventDefault()">
                  +追加
                </button>

              </div>
            </div>

            <div class="button-area">
              <div class="signup-wrapper">
                <button
                mat-raised-button
                [ngClass]="{'delete-mode-btn': deleteMode[m.type], 'yes-btn': !deleteMode[m.type]}"
                (click)="deleteMode[m.type] ? onDel(m.type) : onSave(m.type)"
                [disabled]="
                  deleteMode[m.type] ||
                  isTypeInvalid(m.form) ||
                  cardLoading?.[m?.type]
              "
              >
              保存
              </button>
              @if (cardLoading?.[m?.type]) {
                  <mat-spinner diameter="28" class="spinner2"></mat-spinner>
              }
            </div>
          </div>
          </div>
          <div class="card-footer2" *ngIf="history?.[m.type]?.length && (m.type === 5)">
            最終更新 {{ formatDate(history[m.type][0].created_at) }}
            &nbsp;&nbsp;
            {{ history[m.type][0].officialposition_name }}
            {{ history[m.type][0].updated_name }}
          </div>
          <div class="card-footer2" *ngIf="!history?.[m.type]?.length && (m.type === 5)">
            最終更新 -
          </div>
        </div>
        </ng-container>
      </div>



      <div class="right-column">
        <div class="card half permission-card">

          <div class="title-sub-row2">
            <h3>権限説明マスタ</h3>

            <permission-info class="permission-info-lower"></permission-info>
          </div>
          <span class="title-desc2">
            このマスタで登録した文言は、起案者がイベントの公開範囲を設定する際のナビとして表示されます。例えば、イベントの種類によって選択すべき公開範囲を記載してください。
          </span>

          <div class="label-count" [class.length-red]="form.get('authDescription')?.value?.length > 1000">
            {{ form.get('authDescription')?.value?.length || 0 }}/1000
          </div>
          <div class="memo-wrapper">
            <textarea
              class="memo-textarea"
              formControlName="authDescription"
              maxlength="1000"
              (input)="authDescription = $any($event.target).value">
            ></textarea>
          </div>

          <div class="button-area">
            <div class="signup-wrapper">
              <button
              mat-raised-button
              (click)="authDescriptionOnSave()"
              class="yes-btn"
              [disabled]="
                cardLoading?.[6]
            "
            >
            保存
            </button>
            @if (cardLoading?.[6]) {
                <mat-spinner diameter="28" class="spinner2"></mat-spinner>
            }
          </div>
        </div>

        </div>
        <div class="card-footer2" *ngIf="authDescriptionHistory?.updated_at">
          最終更新 {{ formatDate(authDescriptionHistory.updated_at) }}
          &nbsp;&nbsp;
          {{ authDescriptionHistory.updated_officialposition_name }}
          {{ authDescriptionHistory.updated_last_name }} {{ authDescriptionHistory.updated_first_name }}
        </div>
        <div class="card-footer2" *ngIf="!authDescriptionHistory?.updated_at">
          最終更新 -
        </div>
      </div>
    </div>

    </div>

  </form>
  }